import { call, put, takeLatest } from 'redux-saga/effects';

import * as bannerActions from './bannerActions.js';
import { updateBannerApiCall } from './bannerAPI.js';

function* updateBannerSaga({ payload }) {
  try {
    const { data } = yield call(updateBannerApiCall, payload);
    yield put(bannerActions.bannerUpdateStore(data));
  } catch (error) {
    yield put(bannerActions.bannerUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* bannerWatcher() {
  yield takeLatest(bannerActions.bannerUpdateRequest.type, updateBannerSaga);
}
